import { render, staticRenderFns } from "./LimitedCharsInput.vue?vue&type=template&id=4710e0d1&scoped=true&"
import script from "./LimitedCharsInput.vue?vue&type=script&lang=js&"
export * from "./LimitedCharsInput.vue?vue&type=script&lang=js&"
import style0 from "./LimitedCharsInput.vue?vue&type=style&index=0&id=4710e0d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4710e0d1",
  null
  
)

export default component.exports